import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import AppShell from "./gamzone/AppShell.tsx";
import { App } from "./app/App.tsx";
import { ensureInitialPoints } from "./gamzone/points.ts";
import { applySettings } from "./gamzone/settings.ts";
import { setupPortalChrome } from "./gamzone/embed/portalChrome.ts";
import { ensureAppVersion, checkAppUpdateOnResume } from "./gamzone/native/checkAppUpdate.ts";
import { setupNativeShell } from "./gamzone/native/setupNativeShell.ts";
import "./gamzone/shell.css";
import "./index.css";

function registerServiceWorker() {
  if (!("serviceWorker" in navigator) || !window.isSecureContext) return;
  navigator.serviceWorker
    .register("./sw.js")
    .catch((err) => console.warn("[sw] registration failed:", err));
}

// Re-check for a new deployed build when the tab becomes visible again.
let lastVisibilityCheck = 0;
document.addEventListener("visibilitychange", () => {
  if (document.visibilityState !== "visible") return;
  const now = Date.now();
  if (now - lastVisibilityCheck < 30000) return;
  lastVisibilityCheck = now;
  void checkAppUpdateOnResume();
});

async function bootstrap() {
  void setupNativeShell(); // no-op on web; status bar/splash/back-button on native
  setupPortalChrome();   // portal desktop subpage → inject shared header/footer
  applySettings();       // apply persisted reduced-motion setting
  ensureInitialPoints(); // first-time players start with a 500P wallet

  const versionResult = await ensureAppVersion();
  if (versionResult.action === "reloading") return;

  createRoot(document.getElementById("root")!).render(
    <StrictMode>
      <AppShell initialUpdateNotice={versionResult.action === "manual" ? versionResult : null}>
        <App />
      </AppShell>
    </StrictMode>,
  );
  if (versionResult.action === "ok") registerServiceWorker();
}

void bootstrap();
